// @ts-ignore
import { jitsiLocalStorage } from '@jitsi/js-utils';
import moment from 'moment';
import { getConferenceTimestamp } from '../react/features/base/conference/functions';
import { WILDIX_PLATFORMS } from './components/analytics/kibana/constants';
import WildixEvents from './service/WildixEvents';
export function setStorageData(fieldName, value) {
    jitsiLocalStorage.setItem(fieldName, value);
}
export function getStorageData(fieldName) {
    return jitsiLocalStorage.getItem(fieldName);
}
export function removeStorageData(fieldName) {
    return jitsiLocalStorage.removeItem(fieldName);
}
export function hasStorageDataFlag(fieldName) {
    const flag = getStorageData(fieldName);
    return Boolean(flag && (flag === 'true' || flag === '1'));
}
/**
 * Add user's data to the presence
 * @param getState
 * @param conference
 */
export function enrichPresenceWithUserData(getState, conference) {
    const state = getState();
    const { ctijid, ctiextension, email, displayName, avatarURL, role } = state['features/base/settings'] || {};
    // @ts-ignore
    const { pbxHost } = state['features/base/config'] || {};
    const { room } = conference || {};
    if (!room) {
        return;
    }
    if (ctijid) {
        room.addOrReplaceInPresence('ctijid', { value: ctijid });
    }
    if (ctiextension) {
        room.addOrReplaceInPresence('ctiextension', { value: ctiextension });
    }
    if (ctiextension && pbxHost) {
        room.addOrReplaceInPresence('mainJid', { value: `${ctiextension}@${pbxHost}` });
    }
    if (email) {
        room.addOrReplaceInPresence('email', { value: email });
    }
    if (displayName) {
        room.addOrReplaceInPresence('displayName', { value: displayName });
    }
    if (avatarURL) {
        room.addOrReplaceInPresence('avatar-url', { value: avatarURL });
    }
    if (role) {
        room.addOrReplaceInPresence('role', { value: role });
    }
}
export function showDialogReJoin() {
    if (typeof APP !== 'undefined') {
        APP.wildix.eventEmitter.emit(WildixEvents.OPEN_DIALOG, 'PopupRejoin', { title: 'notification.HaveBeenKicked' });
        APP.conference.needReload = true;
    }
}
export function getLocalParticipantPropertyByTagName(room, // Allow any type and check manually
name) {
    if (!room || typeof room !== 'object' || !room.presMap?.nodes) {
        return undefined;
    }
    const property = room.presMap.nodes.find((prop) => prop.tagName === name);
    return property ? property.value : undefined;
}
export function getUTCTimestamp() {
    return Math.floor(Date.now() / 1000);
}
export function getWildixPlatform(conference) {
    const { isXbees } = conference?.options?.config ?? {};
    const platform = navigator?.product;
    let wildixPlatform = '';
    switch (platform) {
        case 'ReactNative':
            if (isXbees) {
                wildixPlatform = WILDIX_PLATFORMS.RN_XBEES;
            }
            else {
                wildixPlatform = WILDIX_PLATFORMS.RN_COLLABORATION;
            }
            break;
        default:
            if (APP?.wildix?.wizy) {
                wildixPlatform = WILDIX_PLATFORMS.WIZY_HW;
            }
            else if (isXbees) {
                wildixPlatform = WILDIX_PLATFORMS.WEB_XBEES;
            }
            else {
                wildixPlatform = WILDIX_PLATFORMS.WEB_COLLABORATION;
            }
            break;
    }
    return wildixPlatform;
}
export function getLocalConferenceTime(state, format) {
    const conferenceTime = Number(getConferenceTimestamp(state));
    const currentTime = moment(Date.now());
    return currentTime.diff(conferenceTime, format);
}
export async function checkTurnServerAvailability(url) {
    if (!url) {
        return;
    }
    const uri = `${url}/api/resolve`;
    try {
        await fetch(uri);
    }
    catch (error) {
        console.warn('### [Error] Turn server respond', error);
    }
}
export function getUserJidFirstPart(conference) {
    try {
        const xmpp = conference?.xmpp;
        return xmpp?.myJid() ? xmpp.myJid().split('@')[0] : '';
    }
    catch (error) {
        return '';
    }
}
